import('Common/lazy');

export const updateLazy = () => {
    window.aLazyLoad && window.aLazyLoad.update()
    window.bgLazyLoad && window.bgLazyLoad.update()
    window.sliderLazyLoad && window.sliderLazyLoad.update()
};
